<template>
    <section class="confirmation">
        <img :src="image"
            class="image"
        >

        <div class="content">
            <div class="content__title">{{ title }}</div>

            <div class="content__message">
                {{ message }}
            </div>
        </div>

        <div class="buttons">
            <div class="buttons__button buttons__button--success"
                @click="successAction"
            >
                {{ submit.buttonText }}
            </div>

            <div class="buttons__button"
                @click="cancelAction"
            >
                {{ cancel.buttonText }}
            </div>
        </div>
    </section>
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Local Types
import localEpicTypes from '@webapp/store/types.js';

export default {
    name: 'confirmation-modal',
    data() {
        return {
            image: '',
            title: '',
            message: '',
            submit: {
                callback: null,
                buttonText: '',
            },
            cancel: {
                callback: null,
                buttonText: '',
            },
        };
    },
    computed: {
        ...mapGetters(['modal']),
    },
    watch: {
        'modal.data': {
            immediate: true,
            handler(value) {
                if (Object.keys(value)) {
                    this.image = value.image || '';
                    this.title = value.title || '';
                    this.message = value.message || '';
                    this.submit = value.submit || {};
                    this.cancel = value.cancel || {};
                }
            },
        },
    },
    methods: {
        ...mapActions({
            resetModal: localEpicTypes.RESET_MODAL,
        }),

        successAction() {
            this.resetModal();

            this.submit.callback?.();
        },
        cancelAction() {
            this.resetModal();

            this.cancel.callback?.();
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmation {
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 450px;
}

.content {
    padding-top: 2.6rem;
    background: $white-color;
    text-align: center;
    color: $cyprus-color;

    @include max-width(sm) {
        padding-top: 2.6rem;
    }

    &__title {
        font-size: 2rem;
        font-weight: 700;
        line-height: 3.4rem;
    }

    &__message {
        padding: 1rem 0;
        color: $cyprus-color;
        font-size: 1.5rem;
        line-height: 2rem;

        @include max-width(sm) {
            padding: 2rem 0;
        }
    }
}

.image {
    display: block;
    margin: 0 auto;
    object-fit: contain;
    max-width: 13.6rem;
    min-height: 12rem;

    @include min-width(md) {
        max-width: 15.6rem;
        min-height: 16rem;
    }

    @include max-width(sm) {
        max-width: 9.6rem;
        min-height: 11rem;
    }
}

.buttons {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: auto;

    &__button {
        cursor: pointer;
        text-align: center;
        color: $cyprus-color;
        width: 34rem;
        margin: 2rem 0 0;
        font-size: 1.5rem;

        &:hover {
            opacity: 0.8;
        }

        @include max-width(sm) {
            width: 25rem;
        }

        &--success {
            line-height: 4rem;
            border-radius: 0.4rem;
            color: $white-color;
            background: $lima-color;
        }
    }
}
</style>